@use "../../styles/breakpoint.module.scss" as *;

$sidebar-width: 200px;

.filterSidebar {
    order: 0;
    width: $sidebar-width;
    flex-shrink: 0;

    @media ($below-mobile) {
        display: none;
    }
}

.sidebarDisclosure {
    padding-bottom: var(--spacer-16);
    margin-bottom: var(--spacer-16);
    border-bottom: 1px solid var(--gray-300);

    &[data-expanded] {
        .disclosureTrigger {
            padding-bottom: var(--spacer-8);
        }

        .disclosureCaret {
            rotate: -90deg;
        }
    }
}

.disclosureTrigger {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.disclosureCaret {
    width: 20px;
    height: 20px;
    rotate: 90deg;
    transition: rotate 0.2s;
}

.categorySidebarDisclosure {
    margin-bottom: var(--spacer-40);
}

.categoryDisclosureTrigger {
    composes: disclosureTrigger;
    composes: sidebarDisclosure;
}

.categoryHeading {
    padding-bottom: var(--spacer-8);
    font: var(--font-nav-16);
}

.categoryList {
    composes: listReset from "../../styles/composable/utility.module.css";
}

.categoryLink {
    padding-block: var(--spacer-8);
    padding-left: var(--spacer-16);
    font: var(--font-nav-14);

    &[aria-current] {
        text-decoration: var(--gray-900) underline 1px;
        text-underline-offset: 4px;
    }
}

.filterByHeader {
    composes: disclosureTrigger;
    composes: sidebarDisclosure;
}

.clearAll {
    font: var(--font-text-link-14);
    text-decoration: underline;
}

.facetCheckbox {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    gap: var(--spacer-8);
    padding-block: var(--spacer-8);
    font: var(--font-nav-14);
    cursor: pointer;

    &[data-selected] {
        .checkboxBox {
            box-shadow: inset 0 0 0 10px var(--gray-900);
        }

        .check {
            opacity: 1;
        }
    }
}

.check {
    width: 16px;
    height: 13px;
    opacity: 0;
    transition: opacity 0.3s;
    fill: var(--white);
}

.checkboxBox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 1px var(--gray-700);
    transition: box-shadow 0.3s;
}

.filterModal {
    position: fixed;
    inset: 0;
    z-index: 100;
    background-color: var(--white);
}

.filterModalWrapper {
    height: 100dvh;
}

.filterModalHeader {
    position: sticky;
    top: 0;
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-inline: var(--labui-container-margin);
    border-bottom: 1px solid var(--gray-300);
}

.filterModalTitle {
    font: var(--font-nav-16);
    text-transform: uppercase;
}

.filterModalClose {
    --close-size: 40px;
    --close-icon-size: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--close-size);
    height: var(--close-size);
    translate: calc((var(--close-size) - var(--close-icon-size)) / 2) 0;
}

.filterModalCloseIcon {
    width: var(--close-icon-size);
    height: var(--close-icon-size);
}

.filterModalContent {
    height: calc(100% - 100px);
    overflow-y: auto;
    padding: var(--spacer-80) var(--labui-container-margin);
}

.filterModalFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    gap: var(--labui-grid-gap);
    justify-content: space-between;
    padding-inline: var(--labui-container-margin);
    background-color: var(--color-primary);
    border-top: 1px solid var(--gray-300);
}

.filterModalAction {
    width: 100%;
    display: flex;
    justify-content: center;
}
